// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__aiHl_","item":"styles_item__29jfo"};